import { ButtonVariant, IButtonProps } from '@amobee/component-library';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CreativeStatus } from 'src/app/data/constants/creative-status.const';
import { CreativeListVO } from 'src/app/data/vo/CreativeListVO';

@Component({
  selector: 'creative-preview',
  templateUrl: './creative-preview.component.html',
  styleUrls: ['./creative-preview.component.scss']
})
export class CreativePreviewComponent implements OnInit {
  showRejectionNotesInfo: boolean = false;

  @Input() public set creative(creative: CreativeListVO) {
    this._creative = creative;
    if (creative && creative.status) {
      this.showRejectionNotesInfo = creative.status === CreativeStatus.Rejected.key;
    }
    if (creative && creative.creativeFormats && creative.creativeFormats.length) {
      for (let creativeFormat of creative.creativeFormats) {
        if (this.previewableFormats.includes(creativeFormat.formatType)) {
          this.previewUrl = creativeFormat.cdnUrl;
          return;
        }
      }
    }
    this.previewUrl = undefined;
  }
  @Input() open: boolean = false;
  @Output() close = new EventEmitter();

  _creative: CreativeListVO;
  previewUrl: string;
  previewableFormats = ['MP4'];

  okButton: IButtonProps = {
    variant: ButtonVariant.PRIMARY,
    label: 'OK',
    onClick: () => {
      this.cancel();
    }
  };

  constructor() { }

  ngOnInit() {
  }

  cancel() {
    this.open = false;
    this.close.emit();
  }

}
